import { useEffect, useState } from 'react';
import { AwsApiService, AzureApiService } from './_baseService';
import { config } from './_config';

import axios from "axios";

export const useGetData = (path) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        async function fetchData() {
            try {
                const { data: response } = await AzureApiService.get(path, {
                    params: {'subscription-key':`${config.cisApis.subscriptionKey}`}
                });
                setData(response);
            } catch (error) {
                console.error(error);
            }
            setLoading(false);
        };
        fetchData();
    }, [path]);
    return { data, loading };
};

export const getAddressData = async(postcodeEntry) => {
    let response = null;
    let loading = true;
        try {

            //Temporary code to get the address picker working without needing the user to add a space themselves (better UX)
            //TO DO: Remove this code once address API handles the needed space itself
            let space = " ";
            if (!postcodeEntry.includes(space)) {
                let inwardCodePosition = postcodeEntry.length - 3;
                postcodeEntry = postcodeEntry.substring(0, inwardCodePosition) + space + postcodeEntry.substring(inwardCodePosition);
            } 
            
            const {data: value} = await AzureApiService.get(`${config.azureAddress.apiUrl}${postcodeEntry}`, { 
                params: {'subscription-key':`${config.azureAddress.subscriptionKey}`}});
                
            response = value;
        } catch (error) {
            console.error(error);
        } finally {
            loading = false;
        }
    return { response, loading };
}

export const getUtrn = async() => {
    let returnValue = null;
    let returnCode = null;
    let loading = true;
    try {

        const {data:value, status:code} = await AzureApiService(`${config.azureUtrnGenerator.apiUrl}`, 
        {params: {
            'subscription-key': `${config.azureUtrnGenerator.subscriptionKey}`, 
            'api-version':`${config.azureUtrnGenerator.apiVersion}`}});

        returnValue = value;
        returnCode = code;

        } catch (error) {
        console.log({"error":error});
    } finally {
        loading = false;
    }
    return { returnValue, returnCode, loading };
}